<template>
  <main>
    <HeroSection />
    <AboutSection />
    <StatsSection />
    <ServicesSection />
    <ProcessSection />
    <PortfolioSection />
    <!-- <TeamSection /> -->
    <TestimonialsSection />
    <FAQPreviewSection />
    <ContactSection />
  </main>
</template>

<script setup>
import HeroSection from "@/components/sections/HeroSection.vue";
import AboutSection from "@/components/sections/AboutSection.vue";
import StatsSection from "@/components/sections/StatsSection.vue";
import ServicesSection from "@/components/sections/ServicesSection.vue";
import ProcessSection from "@/components/sections/ProcessSection.vue";
import PortfolioSection from "@/components/sections/PortfolioSection.vue";
// import TeamSection from "@/components/sections/TeamSection.vue";
import TestimonialsSection from "@/components/sections/TestimonialsSection.vue";
import FAQPreviewSection from "@/components/sections/FAQPreviewSection.vue";
import ContactSection from "@/components/sections/ContactSection.vue";
</script>
